<div class="flex flex-col tablet:flex-row justify-center items-center gap-8">
    <div [@iconAnimation]="isChecked ? 'check' : 'circle'">
        <lucide-icon [img]="isChecked ? check : circle" [color]="isChecked ? 'green' : 'black'"
            [size]="circleSize"></lucide-icon>
    </div>
    <p-button [label]="isChecked ? 'Accepted' : 'Accept'" (onClick)="handleToggleChange()" />
</div>